import { render, staticRenderFns } from "./documentosAdjuntos.vue?vue&type=template&id=6dd4cb42"
import script from "./documentosAdjuntos.vue?vue&type=script&lang=js"
export * from "./documentosAdjuntos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports